module.exports = __webpack_public_path__ + "static/media/Usermanual_tagging2.46ba805e.png";